import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MediumEnergyIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-mediumEnergy"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M26.7522,13.6767 L24.6142,19.4707 C24.6062,19.4977 24.6262,19.5247 24.6542,19.5247 L31.4122,19.5247 C31.4402,19.5247 31.4602,19.5507 31.4532,19.5777 L28.0132,32.7637 C28.0022,32.8097 28.0622,32.8367 28.0892,32.7987 L41.0002,13.6767 L26.7522,13.6767 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M36.946,0.0844 L30.114,0.0844 C29.6531659,0.0844 29.2460254,0.387904731 29.1156345,0.831233676 L23.7411781,18.7450374 L23.712216,18.8627754 C23.5961088,19.4894607 24.0845644,20.0844 24.738,20.0844 L29.697,20.084 L26.4293745,32.6120097 C26.1253302,33.7266044 27.6172844,34.4266752 28.2871917,33.4733455 L44.1159067,10.7194624 L44.1755432,10.6247031 C44.5516814,9.95136596 44.0686565,9.0844 43.262,9.0844 L35.644,9.084 L37.9428204,1.42376764 C38.1483037,0.756030707 37.6402753,0.0844 36.946,0.0844 Z M35.656,2.084 L33.3581796,9.74503236 L33.3292173,9.86277121 C33.2131088,10.4894607 33.7015644,11.0844 34.355,11.0844 L41.425,11.084 L29.723,27.907 L31.9456255,19.3877903 L31.9697703,19.2727325 C32.0623725,18.6606293 31.5846397,18.0844 30.939,18.0844 L26.027,18.084 L30.827,2.084 L35.656,2.084 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
